import * as React from "react";

import { AgentThread } from "./AgentThread";
import { AgentThreadHistoryView } from "./AgentThreadHistoryView/AgentThreadHistoryView";
import styles from "./AgentThreadSidebarMainContent.module.css";
import { ThreadOpenOnPageNotice } from "./ThreadOpenOnPageNotice";

interface AgentThreadSidebarMainContentProps {
  /** Which pane to show. Comes from the collaboration bar's address rather
   *  than the thread provider, so closing and reopening the bar returns to the
   *  pane you left. */
  showHistory: boolean;

  /** Set when the page behind the sidebar is already showing this thread.
   *  Ranks below ``showHistory``, which is a list rather than a composer and so
   *  collides with nothing. */
  threadShownOnPage: string | null;

  /** Navigate the sidebar to a thread from the history pane. */
  onThreadClicked: (threadId: string) => void;

  /** Navigates to the given thread's own page and closes the sidebar behind
   *  it. Forwarded to the history pane's per-row menu. */
  onOpenThreadInFullView: (threadId: string) => void;
}

/** The chat sidebar's body: the conversation, the thread history pane, or the
 *  open-on-the-page notice. */
export const AgentThreadSidebarMainContent: React.FC<
  AgentThreadSidebarMainContentProps
> = ({
  showHistory,
  threadShownOnPage,
  onThreadClicked,
  onOpenThreadInFullView,
}) => {
  let body: React.ReactNode;
  if (showHistory) {
    body = (
      <AgentThreadHistoryView
        onThreadClicked={onThreadClicked}
        onOpenThreadInFullView={onOpenThreadInFullView}
      />
    );
  } else if (threadShownOnPage !== null) {
    body = <ThreadOpenOnPageNotice threadId={threadShownOnPage} />;
  } else {
    body = <AgentThread />;
  }

  return <div className={styles.mainContainer}>{body}</div>;
};
